import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { autoUpdate, flip, offset, shift, useClick, useDismiss, useFloating, useInteractions } from '@floating-ui/react';
import { IconAccountCircle } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import { HeaderControl } from '../../../components/AccountControl/components/HeaderControl.js';
import { AuthenticationWidget } from '../../../components/Authentication/index.js';
import { AccountLabel } from '../../../components/LoginControl/AccountLabel.js';
import { AccountDropdown } from '../../../components/LoginControl/components/AccountDropdown.js';
import { Container } from '../../../components/LoginControl/components/Container.js';
import { IconContainer } from '../../../components/LoginControl/components/IconContainer.js';
export const AccountControl = ({
  hideLabelBreakpoint,
  username,
  isLoggedIn,
  onLogoutClick,
  onLoginClick
}) => {
  const {
    t
  } = useTranslation();
  const [infoVisible, setInfoVisible] = useState(false);
  const handleSetVisible = state => {
    if (isLoggedIn) setInfoVisible(state);
  };
  const {
    refs,
    context,
    floatingStyles
  } = useFloating({
    open: infoVisible,
    onOpenChange: handleSetVisible,
    middleware: [offset(0), flip(), shift()],
    placement: 'bottom-start',
    whileElementsMounted: autoUpdate
  });
  const {
    getReferenceProps,
    getFloatingProps
  } = useInteractions([useClick(context), useDismiss(context)]);
  const handleOnLoginKeyDown = event => {
    if (event.key === 'Enter') {
      onLoginClick();
    }
  };
  return _jsxs(Container, {
    ref: refs.setReference,
    ...getReferenceProps(),
    children: [_jsxs(HeaderControl, {
      tabIndex: 0,
      onKeyDown: handleOnLoginKeyDown,
      onClick: onLoginClick,
      children: [_jsx(IconContainer, {
        children: _jsx(IconAccountCircle, {})
      }), _jsx(AccountLabel, {
        hideBreakpoint: hideLabelBreakpoint,
        children: username || t('headerNew:login.myAccount')
      })]
    }), isLoggedIn && _jsx(AccountDropdown, {
      infoVisible: infoVisible,
      floatingStyles: floatingStyles,
      getFloatingProps: getFloatingProps,
      refs: refs,
      onLogoutClick: onLogoutClick
    }), _jsx(AuthenticationWidget, {})]
  });
};